export const navigateToTermsOfService = () => {
  window.open("https://www.asiga.com/terms-conditions-genira/", "_blank", "noopener");
};

export const navigateToPrivacyPolicy = () => {
  window.open("https://www.asiga.com/privacy-policy/", "_blank", "noopener");
};
